import { useButtonPressedCallback } from '@zenbusiness/application-commons-clickstream';
import Divider from '@zenbusiness/zui/Divider';
import Stack from '@zenbusiness/zui/Stack';
import { styled } from '@zenbusiness/zui/styles';
import Text from '@zenbusiness/zui/Text';

import MenuItemWithCopy from '../MenuItemWithCopy';

const DividerStyled = styled(Divider)(() => ({
  height: '1px'
}));

const AccountDetails = ({ accountDetails }) => {
  const { accountNumber, routingNumber, name, firstAddressLine, secondAddressLine } =
    accountDetails;

  const buttonPressedTracker = useButtonPressedCallback({
    elementName: 'copy_details_banking_widget',
    elementText: 'copy_details_banking_widget',
    appPageName: 'active_banking_dashboard'
  });

  const trackingClickCopyButtonEvent = () => {
    buttonPressedTracker();
  };

  return [
    <MenuItemWithCopy
      callback={trackingClickCopyButtonEvent}
      copyText={accountNumber}
      key="account-number"
      menuKey="account-number"
      texts={[accountNumber]}
      title="ACCOUNT NUMBER"
    />,
    <MenuItemWithCopy
      callback={trackingClickCopyButtonEvent}
      copyText={routingNumber}
      key="routing-number"
      menuKey="routing-number"
      texts={[routingNumber]}
      title="ROUTING NUMBER"
    />,
    <DividerStyled key="menu-divider" />,
    <Stack
      key="wire-transfer"
      paddingLeft="16px"
    >
      <Text
        color="tertiary"
        size="xs"
        weight="medium"
      >
        For Wire Transfers
      </Text>
    </Stack>,
    <MenuItemWithCopy
      callback={trackingClickCopyButtonEvent}
      copyText={name}
      key="account-name"
      menuKey="account-name"
      texts={[name]}
      title="ACCOUNT NAME"
    />,
    <MenuItemWithCopy
      callback={trackingClickCopyButtonEvent}
      copyText="Thread Bank"
      key="bank-name"
      menuKey="bank-name"
      texts={['Thread Bank']}
      title="BANK NAME"
    />,
    <MenuItemWithCopy
      callback={trackingClickCopyButtonEvent}
      copyText={`${firstAddressLine}, ${secondAddressLine}`}
      key="bank-address"
      menuKey="bank-address"
      texts={[firstAddressLine, secondAddressLine]}
      title="ADDRESS"
    />
  ];
};

export default AccountDetails;
